var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM39(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5438_45410",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5438_45410",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACbklEQVRo3u2aT08TQRjG9yDhYG1J1ISPIMo/RbvYNhy8CgF6gKTWKAd77943MUb00Bt8DGK8YAjhaLlRSA8kBEwaWwhXIEGitVmf18zqlC50rftn3oRNfpfZ3dnfs9uZ3Zmppl1tf7fjYiwKEiALDGAKDFFG+6LKCB99jpG0DgqgDBrAakNDHEvnjB6jjjDudDd4BbZdCLeD6shRnb6LnxR7SH4GVDwQPw/VOXuy3uPbXe8Fyz6In4eu0eu1fBIcBiBvQ9dKeiWfBmcBytvQNdNeyNdDkLepdxxC/GzOQpSXn0SykwZ7qIC83CbcNWzqxgLqbTronaKu7v6sgvI2M27esBWFA1QufWOLV7qlOLmL5DWPvm38ZvuoGHMMoDOQt9GdAhQYBSg4BSgzClB2Gkk1GAVoNI3sxFDPYkZCDpBlGCArBzAYBjDkACbDAOafAH2vV01gMaMpQJ5hgLwcIMMwQEYOEGcYQJcDXAd1RvLkGml6G6Ngg1GAUsu3EArfMgow7xRgmFGA+y0B7rxZoRAlBvJbd+fXnIeU2PmcQYAXF46JsfMa2FFYfhd0XTozsTBtTCw/eWZ9UgxyWpw2JtvOC9XuPdZqA6klYCnGh+pgwt3UIg6+CaoKydfArX+aH8UJD8GpAvLfQLyjGWqc+BR8D1H+Bxj/rzUCEeI0pDs/4ckqDSp6JH6HQcnvA93TdTJqRNQTBCD/Edz2ZaXyoH+MgkyBPR/Ev4D0/mDK/4VuXKgLvARbHoiXwRzVGfiK/deh30/kAXgHSuCnC2E6ZhO8ByPVoZSmzAahCDU+kAF5YAryomwU3Lj6W4y0/QLH7XQgIQBirwAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM39);
export default __webpack_public_path__ + "static/media/m39.6493b9f658d5b96cc0e5b1b34579cc2e.svg";
export { ForwardRef as ReactComponent };